
import { LoadAdminMonthView } from "./LoadAdminMonthView";
import { LoadMonthClocksInfo } from "./LoadMonthClocksInfo";
import { ClockRepo } from '@/modules/working_hours/domain/ClockRepo';
import { UserRepo } from "@/modules/working_hours/domain/UserRepo";

export class WorkingHoursAdminMonthComponent {
  private loadAdminMonthViewUseCase: LoadAdminMonthView;
  private loadMonthClocksInfoUseCase: LoadMonthClocksInfo;
  public userRepo: UserRepo; 
  public clockRepo: ClockRepo; 
  private screenData: any;
  private selectedUser: number | null = null;
  private allClocks: any[] = [];

  constructor(screenData: any, clockRepo: ClockRepo, userRepo: UserRepo) {
    
    this.screenData = screenData;
    this.clockRepo = clockRepo;
    this.userRepo = userRepo;
    
    this.loadAdminMonthViewUseCase = new LoadAdminMonthView(this.userRepo, this.screenData);
    this.loadMonthClocksInfoUseCase = new LoadMonthClocksInfo(this.screenData, this.clockRepo);
  }

  async load_users(): Promise<void> {
    await this.loadAdminMonthViewUseCase.execute();
  }

  async load_user_data(): Promise<void> {
    if (!this.selectedUser) return;
    await this.loadMonthClocksInfoUseCase.execute(this.selectedUser);
    await this.load_all_clocks();
  }

  async load_all_clocks(): Promise<void> {
    try {
      const user = this.screenData.users.find((u: any) => u.id === this.selectedUser);
      
      if (user) {
        const month = this.screenData.currentMonth;
        const year = this.screenData.currentYear;
        const startOfMonth = new Date(year, month - 1, 1);
        const startOfNextMonth = new Date(year, month, 1);
        
        this.allClocks = await this.clockRepo.find_by_criteria(
          [
            ['user_id', '==', user.id],
            ['timestamp', '>=', startOfMonth],
            ['timestamp', '<', startOfNextMonth]
          ],
          ['-timestamp'],
          undefined,
          undefined,
          false
        );
      }
    } catch (error) {
      this.allClocks = [];
    }
  }

  get_day_clocks(date: string): any[] {
    return this.allClocks.filter(clock => {
      const clockDate = new Date(clock.timestamp);
      const targetDate = new Date(date);
      
      return clockDate.getDate() === targetDate.getDate() &&
             clockDate.getMonth() === targetDate.getMonth() &&
             clockDate.getFullYear() === targetDate.getFullYear();
    });
  }

  previous_month(): void {
    if (this.screenData.currentMonth === 1) {
      this.screenData.currentMonth = 12;
      this.screenData.currentYear--;
    } else {
      this.screenData.currentMonth--;
    }
  }

  next_month(): void {
    if (this.screenData.currentMonth === 12) {
      this.screenData.currentMonth = 1;
      this.screenData.currentYear++;
    } else {
      this.screenData.currentMonth++;
    }
  }

  set_selected_user(userId: number): void {
    this.selectedUser = userId;
  }

  get_selected_user(): number | null {
    return this.selectedUser;
  }

  get_all_clocks(): any[] {
    return this.allClocks;
  }

  has_single_user(): boolean {
    return this.screenData.users.length === 1;
  }

  get_first_user_id(): number | null {
    return this.screenData.users.length > 0 ? this.screenData.users[0].id : null;
  }
}